import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';

import css from './TrustClaimBanner.module.css';

// Heart icon from Lucide (ISC license), vendored inline per the template's Icon* convention.
const IconHeart = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="currentColor"
    stroke="none"
  >
    <path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5" />
  </svg>
);

/**
 * Marketing claim banner: "Die grösste Hochzeitsplattform der Schweiz*" with
 * the substantiating footnote. Chrome-free drop-in section — no outer margins,
 * spans whatever width its parent gives it.
 *
 * @param {Object} props
 * @param {string?} props.className
 * @param {string?} props.rootClassName
 */
const TrustClaimBanner = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <section className={classes}>
      <h2 className={css.claim}>
        <FormattedMessage id="TrustClaimBanner.claim" />
        <sup className={css.claimMark}>*</sup>
      </h2>
      <div className={css.divider} aria-hidden="true">
        <span className={css.dividerLine} />
        <span className={css.dividerHeart}>
          <IconHeart />
        </span>
        <span className={css.dividerLine} />
      </div>
      <p className={css.footnote}>
        <FormattedMessage id="TrustClaimBanner.footnote" />
      </p>
    </section>
  );
};

export default TrustClaimBanner;
